export default {"src":"https://images-cdn.curipod.com/d-e1df7c9c/_next/static/media/stars.e76db6a2.svg","height":270,"width":249};